import pokerChip from "@/assets/poker-chip.png";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-muted">
      <div className="container mx-auto px-6 py-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={pokerChip} alt="SplitPot" className="w-6 h-6" />
            <span className="text-sm text-muted-foreground">
              © 2025 SplitPot
            </span>
          </div>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#" className="hover:text-foreground transition-colors">Privacy</a>
            <a href="#" className="hover:text-foreground transition-colors">Terms</a>
            <a href="mailto:prazeresryan@gmail.com" className="hover:text-foreground transition-colors">Support</a>
          </div>
        </div>
      </div>
    </footer>
  );
};